module.exports = __webpack_public_path__ + "static/media/menu.0532f825.svg";